import React from 'react';
import { color as colors, radius } from '../theme';

interface BarProps {
  value: number;
  max?: number;
  color?: string;
  track?: string;
  height?: number;
  // Accessible description, e.g. "56% נוכחות"; without it the bar is decorative
  label?: string;
  style?: React.CSSProperties;
}

// A horizontal bar that fills from the right (RTL), as CLAUDE.md requires
const Bar = ({ value, max = 100, color = colors.primary, track = colors.surfaceMuted, height = 6, label, style }: BarProps) => {
  const pct = max > 0 ? Math.max(0, Math.min(100, (value / max) * 100)) : 0;
  return (
    <div
      role={label ? 'img' : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
      style={{ position: 'relative', height, borderRadius: radius.pill, background: track, overflow: 'hidden', ...style }}
    >
      <div style={{ position: 'absolute', right: 0, top: 0, bottom: 0, width: `${pct}%`, borderRadius: radius.pill, background: color, transition: 'width 0.3s ease' }} />
    </div>
  );
};

export interface BarSegment {
  key: string;
  value: number;
  color: string;
}

// Segments laid side by side from the right, e.g. seats per party in the balance bar
export const SegmentBar = ({ segments, height = 12, label }: { segments: BarSegment[]; height?: number; label?: string }) => {
  let total = 0;
  for (let i = 0; i < segments.length; i++) total += segments[i].value;
  return (
    <div role={label ? 'img' : undefined} aria-label={label} aria-hidden={label ? undefined : true}
      style={{ display: 'flex', gap: 2, height, borderRadius: radius.pill, overflow: 'hidden' }}>
      {segments.map(s => (
        <div key={s.key} style={{ width: total > 0 ? `${(s.value / total) * 100}%` : 0, background: s.color }} />
      ))}
    </div>
  );
};

export default Bar;
